"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Enchanted = void 0;
const Range_1 = require("./Range");
const type_check_1 = require("@pallad/type-check");
const enchant_1 = require("./enchant");
const TYPE_CHECK = new type_check_1.TypeCheck('@pallad/range/enchanted');
var Enchanted;
(function (Enchanted) {
    function is(value) {
        return TYPE_CHECK.isType(value);
    }
    Enchanted.is = is;
    class Shape extends TYPE_CHECK.clazz {
        constructor(comparator) {
            super();
            this.comparator = comparator;
        }
        /**
         * @see Range.map
         */
        map(mapper) {
            return Range_1.Range.map(this, mapper);
        }
        /**
         * @see Range.convert
         */
        convert(mapper, comparator) {
            return (0, enchant_1.enchant)(Range_1.Range.convert(this, mapper, comparator));
        }
        /**
         * @see Range.isWithin
         */
        isWithin(value, exclusive) {
            return Range_1.Range.isWithin(this, value, exclusive, this.comparator);
        }
        /**
         * @see Range.toTuple
         */
        toTuple() {
            return Range_1.Range.toTuple(this);
        }
    }
    Enchanted.Shape = Shape;
})(Enchanted || (exports.Enchanted = Enchanted = {}));
